'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemAnnotationInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseInlineTextArea = require('@bibliocommons/base-inline-text-area');

var _baseInlineTextArea2 = _interopRequireDefault(_baseInlineTextArea);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _utilsList = require('@bibliocommons/utils-list');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/ItemAnnotationInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemAnnotationInput = exports.ItemAnnotationInput = function (_BcReactComponent) {
  _inherits(ItemAnnotationInput, _BcReactComponent);

  function ItemAnnotationInput(props) {
    _classCallCheck(this, ItemAnnotationInput);

    var _this = _possibleConstructorReturn(this, (ItemAnnotationInput.__proto__ || Object.getPrototypeOf(ItemAnnotationInput)).call(this, props));

    _this.bindAll('renderLabelContents');
    return _this;
  }

  _createClass(ItemAnnotationInput, [{
    key: 'renderLabelContents',
    value: function renderLabelContents() {
      if (this.props.renderLabelContents) {
        return this.props.renderLabelContents;
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_edit_list_item_annotation_no_title' });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.allowFreeText) {
        return null;
      }

      var key = this.props.item ? (0, _utilsList.generateKeyForListItem)(this.props.item) : 'new';
      var labelId = key + '-item-annotation-label';
      var inputId = key + '-item-annotation-input';

      return _react2.default.createElement(
        'div',
        { className: 'cp-item-annotation-input' },
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(
            'label',
            { id: labelId, htmlFor: inputId },
            this.renderLabelContents()
          )
        ),
        _react2.default.createElement(
          _baseInlineTextArea2.default,
          {
            id: inputId,
            labelledById: labelId,
            value: this.props.value,
            maxLength: 4000,
            highlightOnHover: true,
            handleChange: this.props.handleChange,
            prompt: this.props.intl.formatMessage({ id: 'user_list_add_annotation' }),
            buttonTestId: 'edit-item-annotation-button',
            inputTestId: 'item-annotation-text-area',
            fitToText: true },
          _react2.default.createElement(
            'span',
            { className: 'user-annotation', 'data-test-id': 'item-annotation-value' },
            this.props.value
          )
        )
      );
    }
  }]);

  return ItemAnnotationInput;
}(_baseBcReactComponent2.default);

ItemAnnotationInput.propTypes = {
  value: _react.PropTypes.string,
  renderLabelContents: _react.PropTypes.element,
  allowFreeText: _react.PropTypes.bool.isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  item: _bcPropTypes.listItemShape,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(ItemAnnotationInput);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/web-results/components/item-annotation-input/components/ItemAnnotationInput.component.js
// module id = 983
// module chunks = 1